import Cookies from 'js-cookie'

const TokenKey = 'LCZWENDAUSERTOKEN'
const ThreeAppKey = 'LCZTHREEAPP'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
} 

export function getThreeApp() {
  return Cookies.get(ThreeAppKey)
}

export function setThreeApp(threeappinfo) {
  return Cookies.set(ThreeAppKey,threeappinfo)
} 

export function removeThreeApp() {
  return Cookies.remove(ThreeAppKey)
} 


// WEBPACK FOOTER //
// ./src/utils/auth.js